import { render, staticRenderFns } from "./memInfo.vue?vue&type=template&id=7124d91a"
import script from "./memInfo.vue?vue&type=script&lang=js"
export * from "./memInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports